import { NOT_AUTHENTICATED_CUSTOMER_ID } from '@ori/presentation-constants';
export var isAuthenticatedCustomer = function isAuthenticatedCustomer(customerId) {
  return typeof customerId === 'number' && customerId !== NOT_AUTHENTICATED_CUSTOMER_ID;
};
//# sourceMappingURL=isAuthenticatedCustomer.js.map